import * as React from 'react'
import { FirestoreCollection, withFirestore } from 'react-firestore'
import PromiseRenderer from './PromiseRenderer'
import MarketItems from './MarketItems'

class Store extends React.Component {
	async buyItem(item) {
		const srnkaRef = this.props.firestore
			.collection('srnky')
			.doc(this.props.srnka.id)
		const owned = this.props.firestore
			.collection('srnky')
			.doc(this.props.srnka.id)
			.collection('owns')
		const srnka = (await srnkaRef.get()).data()
		if (srnka.money >= item.cost) {
			await owned.add({
				purchasedAt: new Date(),
				thing: this.props.firestore.collection('things').doc(item.id)
			})
			await srnkaRef.update({
				money: srnka.money - item.cost
			})
			alert(`Právě jsi koupil: ${item.title}`)
		}
	}

	render() {
		return (
			<FirestoreCollection
				path="things"
				render={({ isLoading, data }) =>
					isLoading ? null : (
						<MarketItems
							items={data.map(item => ({
								buy: () => this.buyItem(item),
								disabled: item.cost > this.props.srnka.money,
								id: item.id,
								title: item.title + ' $' + item.cost
							}))}
						/>
					)
				}
			/>
		)
	}
}

export default withFirestore(Store)



// WEBPACK FOOTER //
// ./src/Store.js